const DisableListNotification = {
  mounted(this: any) {
    const menu = document.querySelector(".dropdown");

    document.addEventListener("mouseup", (e: MouseEvent) => {
      if (menu && !(menu as HTMLElement).contains(e.target as Node)) {
        this.pushEvent("disable_list_notification", { is_active: false });
      }
    });
  },
};

export default DisableListNotification;
